import React, { useEffect, useState } from "react";
import ReusableModal from "../../../../components/Modals/ReusableModal";
import { useUpdateProviderMutation } from "../../../../features/provider/providerApiSlice";
import { useSelector } from "react-redux";
import { selectUser } from "../../../../features/auth/authSlice";
import { useCreateLogsMutation } from "../../../../features/logs/logsApiSlice";
import {
  ACTIVITY_STATUS,
  ACTIVITY_TYPE,
  states,
} from "../../../../constants/config.constants";
import Select from "react-select";

const ProviderQualificationUpdate = ({
  open,
  setOpen,
  setData,
  data: providerData,
  edit,
  setEdit,
  lobs,
  carePrograms,
  payers,
  marketId,
}) => {
  const user = useSelector(selectUser);
  const [qualification, setQualification] = useState(edit);
  const [updateProvider, { isLoading: updateProviderLoading }] =
    useUpdateProviderMutation();
  const [createLog] = useCreateLogsMutation();


  const handleChange = (e) => {
    setQualification({ ...qualification, [e.target.name]: e.target.value });
  };

  const handleUpdateProvider = async () => {
    const payload = {
      activity: `Provider (${providerData.name}) updated by User ${user?.details?.name}`,
      type: ACTIVITY_TYPE.PROVIDER_UPDATE,
      data: {
        providerId: providerData.id,
        marketProfileId: marketId,
      },
    };
    try {
      const filteredQualification = providerData?.qualification?.filter(
        (q) => q.payer !== qualification.payer
      );
      const { data } = await updateProvider({
        ...providerData,
        qualification: filteredQualification
          ? [...filteredQualification, qualification]
          : [qualification],
        providerId: providerData.id,
        marketProfileId: marketId,
      }).unwrap();
      setData((prev) => ({ ...prev, ...data }));
      await createLog({
        ...payload,
        status: ACTIVITY_STATUS.SUCCESS,
      }).unwrap();
    } catch (error) {
      console.error(error?.data?.message);
      await createLog({
        ...payload,
        status: ACTIVITY_STATUS.FAILED,
      }).unwrap();
    }
  };

  return (
    <ReusableModal
      open={open}
      title={
        edit ? "Edit provider qualification" : "Add provider qualification"
      }
      onClose={() => {
        setOpen(false);
        setEdit(null);
      }}
    >
      <div className="flex flex-col items-center min-w-[480px]">
        <div className="h-[1px] w-full bg-primarygrayborder" />
        <div className="flex flex-col w-full gap-4 p-6 overflow-auto max-h-[calc(100vh-200px)]">
          <div className="flex flex-col gap-2">
            <label htmlFor="payer" className="m-0 text-base font-semibold">
              Payer
            </label>
            <Select
              id="payer"
              name="payer"
              options={
                [...(payers || [])]
                  ?.sort((a, b) => a?.name?.localeCompare(b?.name))
                  ?.map((payer) => ({
                    value: payer.name,
                    label: payer.name,
                  }))
              }
              value={
                qualification?.payer
                  ? {
                      value: qualification?.payer,
                      label: qualification?.payer,
                    }
                  : null
              }
              onChange={(e) =>
                handleChange({
                  target: { name: "payer", value: e?.value || '' },
                })
              }
              className="w-full"
              isSearchable
              isClearable
              menuPortalTarget={typeof window !== 'undefined' ? document.body : null} // Render outside modal
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
          </div>
          <div className="flex flex-col gap-2">
            <label htmlFor="payer" className="m-0 text-base font-semibold">
              LOB
            </label>
            <Select
              id="lob"
              name="lob"
              options={
                [...(lobs || [])]
                  ?.sort((a, b) => a?.name?.localeCompare(b?.name))
                  ?.map((lob) => ({
                    value: lob.name,
                    label: lob.name,
                  }))
              }
              isMulti
              value={
                qualification?.lob?.map((lob) => ({
                  value: lob,
                  label: lob,
                })) ?? []
              }
              onChange={(e) =>
                handleChange({
                  target: { name: "lob", value: e.map((e) => e.value) },
                })
              }
              className="w-full"
              isSearchable={true}
              menuPortalTarget={typeof window !== 'undefined' ? document.body : null} // Render outside modal
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
          </div>
          <div className="flex flex-col gap-2">
            <label htmlFor="program" className="m-0 text-base font-semibold">
              Program
            </label>
            <Select
              id="program"
              name="program"
              options={
                [...(carePrograms || [])]
                  .sort((a, b) => a?.abbreviation?.localeCompare(b?.abbreviation))
                  .map((program) => ({
                    value: program.abbreviation,
                    label: program.abbreviation,
                  }))
              }
              isMulti
              value={
                qualification?.program?.map((program) => ({
                  value: program,
                  label: program,
                })) ?? []
              }
              onChange={(e) =>
                handleChange({
                  target: { name: "program", value: e.map((e) => e.value) },
                })
              }
              className="w-full"
              isSearchable={true}
              menuPortalTarget={typeof window !== 'undefined' ? document.body : null} // Render outside modal
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
          </div>
          <div className="flex flex-col gap-2">
            <label htmlFor="state" className="m-0 text-base font-semibold">
              State
            </label>
            <Select
              id="state"
              name="state"
              options={
                states
                  ?.sort((a, b) => a?.localeCompare(b))
                  ?.map((state) => ({
                    value: state,
                    label: state,
                  }))
              }
              value={
                qualification?.state
                  ? {
                      value: qualification?.state,
                      label: qualification?.state,
                    }
                  : null
              }
              onChange={(e) =>
                handleChange({
                  target: { name: "state", value: e?.value || '' },
                })
              }
              className="w-full"
              isSearchable
              isClearable
              menuPortalTarget={typeof window !== 'undefined' ? document.body : null} // Render outside modal
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
          </div>
        </div>
        <div className="justify-end w-full px-3 mb-2 d-flex">
          <button
            className="w-[120px]  disabled:opacity-40 disabled:cursor-not-allowed font-semibold p-1 border-[2px] rounded-md bg-subtleblue border-primaryblue text-primaryblue whitespace-nowrap"
            onClick={async () => {
              await handleUpdateProvider();
              setOpen(false);
            }}
          >
            {updateProviderLoading ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </ReusableModal>
  );
};

export default ProviderQualificationUpdate;
